<template>
  <v-dialog :value="dialogProp.show" persistent max-width="700">
    <v-card class="elevation-12">
      <v-toolbar dense :dark="$vuetify.theme.dark" color="warning">
        <v-toolbar-title>
          {{ $t('Подача ценового предложения') }}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text class="pt-2">
        <v-alert
            class="text-center ma-1"
            outlined
            :value="true"
            type="error">
          {{ warningMessage1 }}
        </v-alert>
        <v-data-table
            :headers="headers"
            :items="dialogProp.premiums || []"
            :items-per-page="-1"
            item-key="positionId"
            disable-sort-by
            :locale="systemLocale"
            hide-default-footer
            dense>
          <!-- eslint-disable-next-line  vue/no-template-shadow, vue/valid-v-slot -->
          <template v-slot:item.positionDescription="{ item }">
            <span :title="item.positionDescription">
              {{ item.positionDescription && item.positionDescription.length > 50
                ? `${item.positionDescription.substring(0,50)}...`
                : item.positionDescription }}
            </span>
          </template>
          <!-- eslint-disable-next-line  vue/no-template-shadow, vue/valid-v-slot -->
          <template v-slot:item.premium="{ item }">
            {{ item.premium }}
          </template>
        </v-data-table>
        <v-divider />
        <v-row class="py-2">
          <v-col class="textcolor--text v-label">
            {{ warningMessage2 }}
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
            id="cancelConfirmBtn"
            color="primary"
            @click="cancel">
          {{ $t('Закрыть') }}
        </v-btn>
        <v-btn
            id="continueOperationBtn"
            color="warning"
            @click.stop="continueOperation">
          {{ $t('Подать') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    components: {
    },
    props: {
      dialogProp: {
        type: Object,
        default: () => {
          return {
            show: false,
            stepCount: null,
            currency: null,
            organizationName: null,
            stepValue: null,
            premiums: [],
            callback: null
          }
        }
      }
    },
    data () {
      return { }
    },
    computed: {
      warningMessage1 () {
        return this.$t('Уведомляем, что отзыв ценового предложения после её отправки в систему ЗАПРЕЩЕН.')
      },
      warningMessage2 () {
        return this.$t('В случае отказа от заключения Договора по предложенной цене {0} будет отказано в участии в следующих процедурах реализации.',
                       [this.dialogProp.organizationName])
      },
      headers () {
        return [
          { text: this.$t('Предмет договора'), align: 'start', sortable: false, value: 'positionDescription' },
          { text: this.$t(this.dialogProp.isFixPremium ? 'Цена 1 (одной) углеродной единицы (с учетом НДС)' : 'Значение дифференциала'), align: 'start', sortable: false, value: 'premium' }
        ]
      }
    },
    methods: {
      continueOperation: function () {
        if (this.dialogProp.callback) {
          this.dialogProp.callback()
        }
        this.cancel()
      },
      cancel: function () {
        this.$emit('close')
        this.$emit('cancel')
      }
    }
  }
</script>
